<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-progress-linear
        :background-color="backgroundColor"
        :color="color"
        height="30"
        :value="progressStatus"
        class="progress-bar"
        v-bind="attrs"
        v-on="on"
      >
        <template v-slot:default="{}">
          <div class="progress-text">{{ lable }}</div>
        </template>
      </v-progress-linear>
    </template>
    <span> {{ lable}} </span>
  </v-tooltip>
</template>

<script>
export default {
  name: "TimerProgressBar",
  props: {
    value: {
      type: Number,
      default: 0,
    },
    color: {
      type: String,
      default: "grey",
    },
    backgroundColor: {
      type: String,
      default: "grey lighten-4",
    },
    lable: String,
  },
  computed: {
    progressStatus: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || 0);
      },
    },
  },
};
</script>

<style scoped>
::v-deep .v-progress-linear__content {
  font-size: 14px !important;
}
.progress-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  text-align: left;
  padding: 0 10px; /* Optional: Add some padding to ensure text doesn't touch the edges */
}
</style>